import ChangeStatus from "./ChangeStatus";
import HoldOrder from "./HoldOrder";

const OrderActionMenu = ({
  actionType,
  handleActionMenu,
  isLoading,
  setOrderActionMenu,
}: any) => {
  return (
    <>
      {actionType === "Change Status" ? (
        <ChangeStatus
          handleActionMenu={handleActionMenu}
          isLoading={isLoading}
        />
      ) : actionType === "Hold/Release" ? (
        <HoldOrder
          handleActionMenu={handleActionMenu}
          isLoading={isLoading}
          setOrderActionMenu={setOrderActionMenu}
        />
      ) : null}
    </>
  );
};

export default OrderActionMenu;
